const GroupingResult = {

  SCENARIOS: 'SCENARIOS'
};

export default GroupingResult;
